export default "__VITE_ASSET__1b0b5a58__"